import { DeliveryGroupDto } from "../../../types/schedule/delivery-group-dto";
import { DeliveryGroupStatus } from "../../../types/schedule/delivery-group-status";
import { DeliveryGroupType } from "../../../types/schedule/delivery-group-type";
import { PreviewDeliveryGroup } from "../../../types/schedule/preview-delivery-group";
import { PreviewDeliveryGroupDto } from "../../../types/schedule/preview-delivery-group-dto";
import { addressFormatByDeliveryGroup } from "../../address/address-format";
import { convertLocationDtoToLocation } from "../location/location-converter";
import { convertPreviewDeliveryInGroupDtoToDeliveryInGroup } from "./preview-delivery-in-group-converter";

export const convertPreviewDeliveryGroupDtoToDeliveryGroup = (
  deliveryGroupDto: PreviewDeliveryGroupDto,
  index: number,
  currentDeliveryGroupIndex?: number
): PreviewDeliveryGroup => {
  return {
    location: convertLocationDtoToLocation(deliveryGroupDto.location),
    type: deliveryGroupDto.type,
    estimatedTimeOfArrival: deliveryGroupDto.estimatedTimeOfArrival,
    startTimeLimited: deliveryGroupDto.startTimeLimited,
    endTimeLimited: deliveryGroupDto.endTimeLimited,
    startedAt: deliveryGroupDto.startedAt,
    reportedAt: deliveryGroupDto.reportedAt,
    deliveriesInGroup: deliveryGroupDto.deliveriesInGroup.map(
      (deliveryInGroupDto) =>
        convertPreviewDeliveryInGroupDtoToDeliveryInGroup(deliveryInGroupDto)
    ),
    startedCount: deliveryGroupDto.startedCount,
    completedCount: deliveryGroupDto.completedCount,
    totalCount: deliveryGroupDto.totalCount,
    issueCount: deliveryGroupDto.issueCount,
    inspectCount: deliveryGroupDto.inspectCount,

    formattedAddress: addressFormatByDeliveryGroup(deliveryGroupDto),

    isPickUp: deliveryGroupDto.type === DeliveryGroupType.PickUp,
    isDropOff: deliveryGroupDto.type === DeliveryGroupType.DropOff,

    displayType:
      deliveryGroupDto.type === DeliveryGroupType.PickUp ? "상차" : "전달",

    isDelay:
      !!deliveryGroupDto.reportedAt &&
      deliveryGroupDto.reportedAt > deliveryGroupDto.endTimeLimited,
    isExpectedDelay:
      !!deliveryGroupDto.estimatedTimeOfArrival &&
      deliveryGroupDto.estimatedTimeOfArrival > deliveryGroupDto.endTimeLimited,

    isWait:
      getDeliveryStatus(index, currentDeliveryGroupIndex) ===
      DeliveryGroupStatus.Wait,
    isWork:
      getDeliveryStatus(index, currentDeliveryGroupIndex) ===
      DeliveryGroupStatus.Work,
    isComplete:
      getDeliveryStatus(index, currentDeliveryGroupIndex) ===
      DeliveryGroupStatus.Reported,

    isSomePickUp: getIsSomePickUp(deliveryGroupDto),
    isSomeDropOff: getIsSomeDropOff(deliveryGroupDto),
  };
};

const getDeliveryStatus = (
  index: number,
  currentDeliveryGroupIndex?: number
) => {
  if (!currentDeliveryGroupIndex) {
    return DeliveryGroupStatus.Wait;
  }

  if (index < currentDeliveryGroupIndex) {
    return DeliveryGroupStatus.Reported;
  }
  if (index === currentDeliveryGroupIndex) {
    return DeliveryGroupStatus.Work;
  }
  return DeliveryGroupStatus.Wait;
};

const getIsSomePickUp = (
  deliveryGroupDto: DeliveryGroupDto | PreviewDeliveryGroupDto
) => {
  return deliveryGroupDto.deliveriesInGroup.some((deliveryInGroupDto) => {
    if (deliveryGroupDto.type === DeliveryGroupType.PickUp) {
      return !!deliveryInGroupDto.inProgressAction.completedAt;
    }
    return !!deliveryInGroupDto.pairAction.completedAt;
  });
};

const getIsSomeDropOff = (
  deliveryGroupDto: DeliveryGroupDto | PreviewDeliveryGroupDto
) => {
  return deliveryGroupDto.deliveriesInGroup.some((deliveryInGroupDto) => {
    if (deliveryGroupDto.type === DeliveryGroupType.DropOff) {
      return !!deliveryInGroupDto.inProgressAction.completedAt;
    }
    return !!deliveryInGroupDto.pairAction.completedAt;
  });
};

// const getDeliveryStatus = (
//   deliveryGroupDto: DeliveryGroupDto | PreviewDeliveryGroupDto
// ) => {
//   if (deliveryGroupDto.reportedAt) {
//     return DeliveryGroupStatus.Reported;
//   }
//   if (deliveryGroupDto.startedAt) {
//     return DeliveryGroupStatus.Work;
//   }
//   return DeliveryGroupStatus.Wait;
// };
